export default "__VITE_ASSET___E2Kg7X4__"